import React from 'react'

import { ReportResultLayout } from 'components/ReportResultLayout'
import { ReportByThemeTable, ReportByThemeTableProps } from 'components/ReportTables'

interface ReportByThemeProps extends ReportByThemeTableProps {
  onDownload: () => void
}

export const ReportByB2B: React.FC<ReportByThemeProps> = ({ onDownload, data }) => {
  return (
    <ReportResultLayout
      onDownload={onDownload}
      title="Інформація щодо кількості прийнятих звернень кол-центром електропостачальника по сегменту В2В"
    >
      <ReportByThemeTable data={data} />
    </ReportResultLayout>
  )
}
